<template>
  <div>
    <MessageDescriptionList :item="model" />

    <InfuseJsonCodeBlock :payload="model.chargePointMessage" :scrollable="false" class="w-full" />
  </div>
</template>

<script setup lang="ts">
import { InfuseJsonCodeBlock } from '@infuse/ui/components';
import { Message } from '@infuse/e-connector/message/domain';
import { MessageDescriptionList } from '@infuse/e-connector/message/ui';

interface Props {
  model: Message;
}
withDefaults(defineProps<Props>(), {});
</script>
